import { ROUTER } from './router.actions';

export function RouterEpic($window) {
  'ngInject';
  return (action, { dispatch, getState }) => {
    const { type, payload } = action;

    if (type === ROUTER.CHANGE_LOCATION) {
      $window.location.href = payload.location;
    }
  };
}
